/* eslint-disable jira/filename-case */
import React, { Component } from 'react';
import noop from 'lodash/noop';
import withAnalyticsContext from '@atlaskit/analytics-next/withAnalyticsContext';
import withAnalyticsEvents from '@atlaskit/analytics-next/withAnalyticsEvents';
import { PAGE_EVENT_ACTION } from '../utils/events.tsx';

type Props = {
	onMount: () => void;
};

// eslint-disable-next-line jira/react/no-class-components
class ViewTracker extends Component<Props> {
	componentDidMount() {
		this.props.onMount();
	}

	render() {
		return null;
	}
}

const ViewTrackerWithAnalytics = withAnalyticsContext({
	componentName: 'view-tracker',
})(
	withAnalyticsEvents({
		onMount: (createEvent) => createEvent({ action: PAGE_EVENT_ACTION }).fire(),
	})(ViewTracker),
);

const ViewTrackerWithNoopOnMount = (): React.JSX.Element => (
	<ViewTrackerWithAnalytics onMount={noop} />
);

export default ViewTrackerWithNoopOnMount;
